import { render, staticRenderFns } from "./point.vue?vue&type=template&id=a039f324&scoped=true&"
import script from "./point.vue?vue&type=script&lang=ts&"
export * from "./point.vue?vue&type=script&lang=ts&"
import style0 from "./point.vue?vue&type=style&index=0&id=a039f324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a039f324",
  null
  
)

export default component.exports